<template>
  <crm-side-panel @handleClose="handleDialogClose('thisDialog')" :title="customFullName">
    <div class="side-panel-content busi-detail-content custom-details">
      <div class="side-panel-buttons">
        <crm-button
          v-if="
            authEdit &&
            customDetail.commonCustomer.categoryUid !== 'b8b2e093efd548a18259807bcb7fda2f'
          "
          :size="'mini'"
          :text="'编辑'"
          @click="handleDialogShow('customEdit')"
        >
        </crm-button>
        <crm-button
          v-if="
            authDelete &&
            (isDoctorOperator ||
              customDetail.commonCustomer.categoryUid ===
                'b8b2e093efd548a18259807bcb7fda2f')
          "
          :size="'mini'"
          :buttonType="'danger'"
          :text="'删除'"
          @click="handleDelete()"
        >
        </crm-button>
        <crm-button
          v-if="
            authDelete &&
            customDetail.commonCustomer.categoryUid !== 'b8b2e093efd548a18259807bcb7fda2f'
          "
          :size="'mini'"
          :buttonType="'danger'"
          :text="'释放公海'"
          @click="handleDelete()"
        >
        </crm-button>
      </div>
      <div class="side-panel-header">
        <!-- 头部信息 -->
        <div class="header-info">
          <div class="info-item">
            <p class="info-title">客户编号</p>
            <p class="info-detail">
              {{ customDetail.commonCustomer.customerNo }}
            </p>
          </div>
          <div class="info-item">
            <p class="info-title">客户类型</p>
            <p class="info-detail">
              {{ customDetail.commonCustomer.categoryName }}
            </p>
          </div>
          <div class="info-item">
            <p class="info-title">客户等级</p>
            <p class="info-detail">
              {{ customDetail.commonCustomer.customerLevelName || "暂无等级" }}
            </p>
          </div>
          <div
            class="info-item"
            v-if="
              customDetail.commonCustomer.categoryUid !==
              'b8b2e093efd548a18259807bcb7fda2f'
            "
          >
            <p class="info-title">签约状态</p>
            <p class="info-detail">
              {{
                customDetail.commonCustomer.contractStatus === "1" ? "已签约" : "未签约"
              }}
            </p>
          </div>
          <div class="info-item">
            <p class="info-title">业务员</p>
            <p class="info-detail">
              {{ customDetail.commonCustomer.salesmanName }}
            </p>
          </div>
        </div>
      </div>
      <div class="side-panel-tabs">
        <el-tabs v-model="tabActiveName" @tab-click="handleTabClick" v-loading="loading">
          <!-- 详情信息 -->
          <el-tab-pane label="详情信息" name="details">
            <pane-info
              @toDetail="toClueDetail"
              :common="customDetail.commonCustomer"
              :detail="customDetail"
            ></pane-info>
          </el-tab-pane>
          <!-- 业务员 -->
          <el-tab-pane label="业务员" name="salesman">
            <div>
              <crm-button
                :size="'mini'"
                :text="'新增'"
                class="fr mb10"
                @click="handleDialogShow('salesman')"
                v-if="getModuleAuth('customerAddSalesman', 'medicalCustomerAddSalesman')"
              >
              </crm-button>
            </div>
            <el-table :data="customSalesman.results" height="100%" style="width: 100%">
              <el-table-column prop="salesmanName" align="center" label="姓名">
              </el-table-column>
              <el-table-column prop="teamName" align="center" width="350" label="团队">
              </el-table-column>
              <el-table-column prop="gmtCreated" align="center" label="添加时间">
                <template slot-scope="scope">
                  {{ scope.row.gmtCreated | formatTimeShow }}
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-button
                    @click="handleDialogShow('salesman', scope)"
                    v-if="
                      getModuleAuth(
                        'customerUpdateSalesman',
                        'medicalCustomerUpdateSalesman'
                      )
                    "
                    type="text"
                    size="small"
                  >
                    替换
                  </el-button>
                  <el-button
                    @click="handleDeleteSalesman(scope)"
                    v-if="
                      getModuleAuth(
                        'customerDeleteSalesman',
                        'medicalCustomerDeleteSalesman'
                      )
                    "
                    type="text"
                    size="small"
                  >
                    删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <!-- 联系人 -->
          <el-tab-pane
            label="联系人"
            name="contacts"
            v-if="getModuleAuth('customerConvertTab', 'medicalCustomerConvertTab')"
          >
            <div>
              <crm-button
                v-if="getModuleAuth('customerAddConvert', 'medicalCustomerAddConvert')"
                :size="'mini'"
                :text="'新增'"
                class="fr mb10"
                @click="handleDialogShow('contacts')"
              >
              </crm-button>
            </div>
            <el-table :data="customContacts.results" height="100%" style="width: 100%">
              <el-table-column prop="name" align="center" label="姓名"> </el-table-column>
              <el-table-column prop="mobile" align="center" label="联系方式">
              </el-table-column>
              <el-table-column prop="typeName" align="center" label="类型">
              </el-table-column>
              <el-table-column prop="duty" align="center" label="职务"> </el-table-column>
              <el-table-column prop="contactDepa" align="center" label="部门">
              </el-table-column>
              <el-table-column prop="contactEmail" align="center" label="邮箱">
              </el-table-column>
              <el-table-column prop="landline" align="center" label="座机">
              </el-table-column>
              <el-table-column prop="contactQQ" align="center" label="微信/QQ">
              </el-table-column>
              <el-table-column prop="salesmanName" align="center" label="业务员">
              </el-table-column>
              <el-table-column
                prop="createdDate"
                align="center"
                width="150"
                label="创建时间"
              >
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-button
                    v-if="
                      getModuleAuth(
                        'customerUpdateConvert',
                        'medicalCustomerUpdateConvert'
                      ) && scope.row.salesmanCode === userInfo.userUid
                    "
                    @click="handleDialogShow('contacts', scope)"
                    type="text"
                    size="small"
                  >
                    修改
                  </el-button>
                  <el-button
                    @click="handleDeleteConvert(scope)"
                    v-if="
                      getModuleAuth(
                        'customerDeleteConvert',
                        'medicalCustomerDeleteConvert'
                      )
                    "
                    type="text"
                    size="small"
                  >
                    删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="pageination">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="contacts.pageNumber"
                :page-sizes="[10, 20, 30, 40]"
                :page-size="contacts.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="customContacts.totalCount"
              >
              </el-pagination>
            </div>
          </el-tab-pane>
          <!-- 客户档案 -->
          <el-tab-pane
            label="客户档案"
            name="archive"
            v-if="getModuleAuth('customerFileTab', 'medicalCustomerFileTab')"
          >
            <el-upload
              class="mb10 text-right"
              action="string"
              :show-file-list="false"
              :before-upload="beforeAvatarUpload"
              :http-request="handleUploadFile"
            >
              <crm-button
                v-if="getModuleAuth('customerFileUpload', 'medicalCustomerFileUpload')"
                :buttonType="'secondary'"
                :size="'mini'"
                :text="'上传附件'"
              >
                <el-tooltip
                  content="图片文件单个不能超过5M；其他文件单个不能超过50M"
                  class="item"
                  effect="dark"
                  placement="top"
                >
                  <span class="el-icon-question" style="font-size: 16px"></span>
                </el-tooltip>
              </crm-button>
            </el-upload>
            <el-table
              :data="customArchiveData.results"
              class="tab-table-item"
              height="100%"
              style="width: 100%"
            >
              <el-table-column
                prop="creatorName"
                label="操作人"
                width="100"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="gmtCreated"
                label="上传时间"
                width="150"
                align="center"
              >
                <template slot-scope="scope">
                  {{ scope.row.gmtCreated | formatTimeShow }}
                </template>
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                prop="fileUrl"
                label="附件"
                align="center"
              >
                <template slot-scope="scope">
                  <a
                    v-if="
                      getModuleAuth('customerFileTab', 'medicalCustomerFileTab') &&
                      scope.row.previewUrl
                    "
                    href="javascript:;"
                    @click="getFildUrl(scope.row)"
                  >
                    {{ scope.row.fileName }}
                  </a>
                  <span v-else>{{ scope.row.fileName || "暂无数据" }}</span>
                </template>
              </el-table-column>
              <el-table-column width="100" label="操作" align="center">
                <template slot-scope="scope">
                  <el-button
                    v-if="
                      getModuleAuth('customerFileDelete', 'medicalCustomerFileDelete')
                    "
                    @click="handleDeleteFile(scope)"
                    type="text"
                    size="small"
                  >
                    删除
                  </el-button>

                  <a
                    v-if="
                      getModuleAuth(
                        'customerFileDownload',
                        'medicalCustomerFileDownload'
                      ) && scope.row.fileUrl
                    "
                    :href="scope.row.fileUrl"
                  >
                    下载
                  </a>
                </template>
              </el-table-column>
            </el-table>
            <div class="pageination">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="archive.pageNumber"
                :page-sizes="[5, 10, 20]"
                :page-size="archive.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="customArchiveData.totalCount"
              >
              </el-pagination>
            </div>
          </el-tab-pane>
          <!-- 最终客户 -->
          <el-tab-pane
            label="最终客户"
            name="finallyCustom"
            v-if="getModuleAuth('finalCustomerTab', 'medicalFinalCustomerTab')"
          >
            <div>
              <crm-button
                :size="'mini'"
                :text="'新增'"
                class="fr mb10"
                @click="handleDialogShow('finallyCus')"
                v-if="getModuleAuth('finalCustomerAdd', 'medicalFinalCustomerAdd')"
              >
              </crm-button>
            </div>
            <el-table :data="finallyCustomData.results" height="100%" style="width: 100%">
              <el-table-column
                prop="customerName"
                show-overflow-tooltip
                align="center"
                label="最终客户名称"
              >
              </el-table-column>
              <el-table-column prop="remark" width="400" align="center" label="备注">
              </el-table-column>
              <el-table-column prop="gmtCreated" align="center" label="创建时间">
                <template slot-scope="scope">
                  {{ scope.row.gmtCreated | formatTimeShow }}
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-button
                    v-if="
                      getModuleAuth('finalCustomerUpdate', 'medicalFinalCustomerUpdate')
                    "
                    @click="handleDialogShow('finallyCus', scope)"
                    type="text"
                    size="small"
                  >
                    修改
                  </el-button>
                  <el-button
                    @click="handleDeleteFinallyCus(scope)"
                    v-if="getModuleAuth('finalCustomerDel', 'medicalFinalCustomerDel')"
                    type="text"
                    size="small"
                  >
                    删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="pageination">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="finallyCustom.pageNumber"
                :page-sizes="[10, 20, 30, 40]"
                :page-size="finallyCustom.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="finallyCustomData.totalCount"
              >
              </el-pagination>
            </div>
          </el-tab-pane>
          <!-- 拜访记录 -->
          <el-tab-pane
            label="拜访记录"
            name="visits"
            v-if="getModuleAuth('customerVisitTab', 'medicalCustomerVisitTab')"
          >
            <div>
              <crm-button
                :size="'mini'"
                :text="'拜访'"
                class="fr mb10"
                @click="toVisit"
                v-if="visitAuth.visitAdd && visitAuth.visitAdd.toggleStatus"
              >
              </crm-button>
            </div>
            <el-table :data="customVisits.results" height="100%" style="width: 100%">
              <el-table-column prop="visitDateStr" align="center" label="拜访时间">
              </el-table-column>
              <el-table-column
                prop="visitTypeName"
                align="center"
                width="88"
                label="拜访方式"
              >
              </el-table-column>
              <el-table-column
                prop="visitAim"
                align="center"
                show-overflow-tooltip
                label="拜访事宜"
              >
              </el-table-column>
              <el-table-column
                prop="isFinishedStr"
                align="center"
                width="88"
                label="是否完成"
              >
              </el-table-column>
              <el-table-column
                prop="visitNote"
                align="center"
                show-overflow-tooltip
                label="拜访结果"
              >
              </el-table-column>
              <el-table-column
                prop="salesmanName"
                align="center"
                width="88"
                label="业务员"
              >
              </el-table-column>
              <el-table-column
                prop="teamName"
                align="center"
                show-overflow-tooltip
                label="团队"
              >
              </el-table-column>
            </el-table>
            <div class="pageination">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="visits.pageNumber"
                :page-sizes="[10, 20, 30, 40]"
                :page-size="visits.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="customVisits.totalCount"
              >
              </el-pagination>
            </div>
          </el-tab-pane>
          <!-- 客户商机 -->
          <el-tab-pane
            label="商机"
            name="busi"
            v-if="getModuleAuth('customerBizTab', 'medicalCustomerBizTab')"
          >
            <div>
              <crm-button
                v-if="getModuleAuth('customerAddBusiness', 'medicalCustomerAddBusiness')"
                :size="'mini'"
                :text="'新增商机'"
                class="fr mb10"
                @click="handleDialogShow('busi')"
              >
              </crm-button>
            </div>
            <el-table :data="customBusi.results" height="100%" style="width: 100%">
              <el-table-column
                prop="name"
                show-overflow-tooltip
                width="130"
                align="center"
                label="商机名称"
              >
                <template slot-scope="scope">
                  <span class="link" @click.stop="handleBusiDetailShow(scope)">
                    {{ scope.row.name || "暂无数据" }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                prop="dealDateStr"
                align="center"
                width="110"
                label="预计成交日期"
              >
              </el-table-column>
              <el-table-column
                prop="dealAmountStr"
                align="center"
                width="130"
                label="预计成交金额(元)"
              >
                <template slot-scope="scope">
                  {{ formatMoney(scope.row.dealAmountStr) }}
                </template>
              </el-table-column>
              <el-table-column
                prop="businessTypeName"
                align="center"
                width="80"
                label="商机阶段"
              >
              </el-table-column>
              <el-table-column prop="userName" align="center" width="80" label="业务员">
              </el-table-column>
              <el-table-column
                prop="intention"
                align="center"
                show-overflow-tooltip
                label="客户意向"
              >
              </el-table-column>
              <el-table-column
                prop="gmtCreatedStr"
                align="center"
                width="100"
                label="创建时间"
              >
              </el-table-column>
              <el-table-column
                prop="visitDateStr"
                align="center"
                width="110"
                label="最后跟进时间"
              >
              </el-table-column>
            </el-table>
            <div class="pageination">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="busi.pageNumber"
                :page-sizes="[10, 20, 30, 40]"
                :page-size="busi.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="customBusi.totalCount"
              >
              </el-pagination>
            </div>
          </el-tab-pane>
          <!-- 合同 -->
          <el-tab-pane
            label="合同"
            name="compact"
            v-if="getModuleAuth('customerContractTab', 'medicalCustomerContractTab')"
          >
            <div>
              <el-dropdown
                trigger="click"
                @command="handleAddContract"
                class="fr mb10"
                v-if="getModuleAuth('customerAddContract', 'medicalCustomerAddContract')"
              >
                <crm-button :size="'mini'" :text="'新增'">
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </crm-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="addNew">新增合同</el-dropdown-item>
                  <el-dropdown-item command="addHad">已有合同</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <el-table :data="customCompact.results" height="100%" style="width: 100%">
              <el-table-column prop="contractNo" align="center" label="合同编号">
                <template slot-scope="scope">
                  <span class="link" @click="handleCompactDetailShow(scope)">{{
                    scope.row.contractNo
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="contractAmount" align="center" label="合同金额(元)">
                <template slot-scope="scope">
                  {{ formatMoney(scope.row.contractAmount) }}
                </template>
              </el-table-column>
              <el-table-column prop="refundAmount" align="center" label="回款金额(元)">
                <template slot-scope="scope">
                  {{ formatMoney(scope.row.refundAmount) }}
                </template>
              </el-table-column>
              <el-table-column
                prop="receivableAmount"
                align="center"
                label="应收金额(元)"
              >
                <template slot-scope="scope">
                  {{ formatMoney(scope.row.receivableAmount) }}
                </template>
              </el-table-column>
              <el-table-column prop="settlementName" align="center" label="结算方式">
              </el-table-column>
              <el-table-column
                prop="startDate"
                align="center"
                width="100"
                label="开始日期"
              >
              </el-table-column>
              <el-table-column prop="endDate" align="center" width="110" label="结束日期">
              </el-table-column>
              <el-table-column prop="userName" align="center" width="110" label="业务员">
              </el-table-column>
            </el-table>
            <div class="pageination">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="compact.pageNumber"
                :page-sizes="[10, 20, 30, 40]"
                :page-size="compact.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="customCompact.totalCount"
              >
              </el-pagination>
            </div>
          </el-tab-pane>
          <!-- 项目 -->
          <el-tab-pane
            label="项目"
            name="project"
            v-if="getModuleAuth('customerProjectTab', 'medicalCustomerProjectTab')"
          >
            <div>
              <el-dropdown
                class="fr mb10"
                trigger="click"
                @command="handleAddProject"
                v-if="getModuleAuth('customerAddProject', 'medicalCustomerAddProject')"
              >
                <crm-button :size="'mini'" :text="'新增项目'">
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </crm-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="addNew">新项目</el-dropdown-item>
                  <el-dropdown-item command="addHad">已有项目</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>

            <el-table :data="projectDetailList.results" height="100%" style="width: 100%">
              <el-table-column prop="projectName" align="center" label="项目名称">
              </el-table-column>
              <el-table-column
                prop="salesmanName"
                align="center"
                show-overflow-tooltip
                label="业务员"
              >
              </el-table-column>
              <el-table-column
                prop="projectDetailVO.onlineDateStr"
                align="center"
                width="88"
                label="上线日期"
              >
              </el-table-column>
              <el-table-column
                prop="projectDetailVO.importDeadlineStr"
                align="center"
                show-overflow-tooltip
                label="导入截止日期"
              >
              </el-table-column>
              <el-table-column
                prop="projectSourceId"
                align="center"
                show-overflow-tooltip
                label="sourceid"
              >
              </el-table-column>
            </el-table>
            <div class="pageination">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="project.pageNumber"
                :page-sizes="[10, 20, 30, 40]"
                :page-size="project.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="projectDetailList.totalCount"
              >
              </el-pagination>
            </div>
          </el-tab-pane>
          <!-- 操作记录 -->
          <el-tab-pane
            label="操作记录"
            name="operateLog"
            v-if="getModuleAuth('doctorOperationLogTab', 'doctorOperationLogTab')"
          >
            <el-timeline :reverse="true">
                <el-timeline-item
                    v-for="(activity, index) in activities"
                    :key="index"
                    type="primary">
                    <div>
                        <div class="time">{{ activity.gmtCreated | formatTimeFull}}</div>
                        <div>{{activity.createName}}</div>
                        <div>
                            <span>{{activity.content}}</span>
                        </div>
                    </div>
                </el-timeline-item>
            </el-timeline>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>

    <!-- 商机详情面板 -->
    <transition name="slide-fade">
      <div v-show="busiDetailVisible">
        <busi-detail
          :nextButtonState="nextButtonState"
          :detailId="detailId"
          :isShangJi="false"
          @handleCloseBusiDetail="handleCloseBusiDetail"
        >
        </busi-detail>
      </div>
    </transition>

    <!-- 客户详情面板 -->
    <transition name="slide-fade">
      <template v-if="envCrm">
        <div v-show="compactDetailVisibleInside">
          <compact-detail-inside
            :visible="compactDetailVisibleInside"
            :row="compactRow"
            :detailId="detailId"
            @handleCloseDetail="handleCloseCompactDetail"
          >
          </compact-detail-inside>
        </div>
      </template>
      <template v-else>
        <div v-show="compactDetailVisible">
          <compact-detail
            :row="row"
            :detailId="compactDetailId"
            @handleCloseDetail="handleCloseCompactDetail"
          >
          </compact-detail>
        </div>
      </template>
    </transition>

    <!-- 新增合同弹窗 -->
    <add-compact
      v-if="addCompactDialogVisible"
      :customId="uid"
      :customName="customFullName"
      :detail="compactDetail"
      @close="handleDialogClose('contract')"
      @success="updatePanel()"
    >
    </add-compact>

    <!-- 新增项目弹窗 -->
    <add-project
      v-if="addProjectDialogVisible"
      :mode="'add'"
      :customerId="uid"
      :customerName="customDetail.commonCustomer.name"
      @close="handleDialogClose('project')"
      @success="updatePanel()"
    >
    </add-project>

    <add-busi
      v-if="isAddBusiVisible"
      :visible="isAddBusiVisible"
      :moduleName="'opportunity'"
      :customId="uid"
      :customName="customFullName"
      @close="isAddBusiVisible = false"
      @success="updatePanel()"
    >
    </add-busi>

    <!-- 新增联系人弹窗 -->
    <el-dialog
      title="新增联系人"
      :visible.sync="addConvertVisibility"
      width="60%"
      append-to-body
      @close="handleDialogClose('contacts', true)"
    >
      <div class="dialog-body clearfix">
        <el-form
          label-width="120px"
          ref="addConvertForm"
          :model="addConvertForm"
          :rules="convertFormRules"
        >
          <el-col :span="11">
            <el-form-item label="联系人：" prop="name">
              <el-input v-model="addConvertForm.name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="联系方式：" prop="mobile">
              <el-input v-model="addConvertForm.mobile"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="联系人职务：" prop="duty">
              <el-input v-model="addConvertForm.duty"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="联系人类型：" prop="contactType">
              <el-select clearable v-model="addConvertForm.contactType" value-key="uid">
                <el-option
                  v-for="item in contactsType ? contactsType.results : ''"
                  :label="item.name"
                  :value="item.uid"
                  :key="item.uid"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="联系人部门：" prop="contactDepa">
              <el-input v-model="addConvertForm.contactDepa"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="联系人邮箱：" prop="contactEmail">
              <el-input v-model="addConvertForm.contactEmail"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="座机：" prop="landline">
              <el-input v-model="addConvertForm.landline"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="微信/QQ：" prop="contactQQ">
              <el-input v-model="addConvertForm.contactQQ"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="业务员：" prop="salesmanCode">
              <el-select clearable v-model="addConvertForm.salesmanCode" value-key="uid">
                <el-option
                  v-for="item in customSalesman.results"
                  :label="item.salesmanName"
                  :value="item.salesmanCode"
                  :key="item.uid"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-form>
      </div>
      <div slot="footer" style="text-align: right">
        <crm-button
          :buttonType="'plain'"
          :text="'取消'"
          @click="handleDialogClose('contacts', true)"
        >
        </crm-button>
        <crm-button :text="'保存'" @click="handleAddConvert"></crm-button>
      </div>
    </el-dialog>

    <!-- 修改联系人弹窗 -->
    <el-dialog
      title="修改联系人"
      :visible.sync="updateConvertVisibility"
      append-to-body
      @close="handleDialogClose('contacts')"
    >
      <div class="dialog-body">
        <el-form
          label-width="120px"
          ref="updateConvertForm"
          :model="updateConvertForm"
          :rules="convertFormRules"
        >
          <el-col :span="11">
            <el-form-item label="联系人：" prop="name">
              <el-input v-model="updateConvertForm.name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="联系方式：" prop="mobile">
              <el-input v-model="updateConvertForm.mobile"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="联系人职务：" prop="duty">
              <el-input v-model="updateConvertForm.duty"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="联系人类型：" prop="contactType">
              <el-select
                clearable
                v-model="updateConvertForm.contactType"
                value-key="uid"
              >
                <el-option
                  v-for="item in contactsType ? contactsType.results : ''"
                  :label="item.name"
                  :value="item.uid"
                  :key="item.uid"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="联系人部门：" prop="contactDepa">
              <el-input v-model="updateConvertForm.contactDepa"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="联系人邮箱：" prop="contactEmail">
              <el-input v-model="updateConvertForm.contactEmail"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="座机：" prop="landline">
              <el-input v-model="updateConvertForm.landline"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="微信/QQ：" prop="contactQQ">
              <el-input v-model="updateConvertForm.contactQQ"></el-input>
            </el-form-item>
          </el-col>
        </el-form>
      </div>
      <div slot="footer" style="text-align: right">
        <crm-button
          :buttonType="'plain'"
          :text="'取消'"
          @click="handleDialogClose('contacts')"
        >
        </crm-button>
        <crm-button :text="'保存'" @click="handleUpdateConvert"></crm-button>
      </div>
    </el-dialog>

    <!-- 添加业务员弹窗 -->
    <el-dialog
      title="添加业务员"
      width="30%"
      :visible.sync="addSalesmanDialogVisible"
      append-to-body
      @close="handleDialogClose('salesman', true)"
    >
      <el-form :model="addSalesmanForm" label-width="120px" ref="addSalesmanForm">
        <el-form-item
          label="业务员:"
          prop="code"
          :rules="{
            required: true,
            message: '请选择业务员',
            trigger: 'change',
          }"
        >
          <el-select filterable v-model="addSalesmanForm.code" placeholder="请选择业务员">
            <el-option
              v-for="item in clerkList"
              :label="`${item.userName} - ${item.loginId}`"
              :value="item.code"
              :key="item.code"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <crm-button
          :buttonType="'plain'"
          :text="'取消'"
          @click="handleDialogClose('salesman', true)"
        >
        </crm-button>
        <crm-button :text="'确定'" @click="handleAddSalesman()"></crm-button>
      </div>
    </el-dialog>

    <!-- 修改业务员弹窗 -->
    <el-dialog
      title="修改业务员"
      width="50%"
      :visible.sync="editSalesmanDialogVisible"
      append-to-body
      @close="handleDialogClose('salesman')"
    >
      <el-form :model="editSalesmanForm" label-width="120px" ref="editSalesmanForm">
        <el-form-item label="当前业务员:">
          {{ editSalesmanForm.name }}
        </el-form-item>
        <el-form-item
          label="替换后业务员:"
          prop="newCode"
          :rules="{
            required: true,
            message: '请选择替换后业务员',
            trigger: 'change',
          }"
        >
          <el-select
            filterable
            v-model="editSalesmanForm.newCode"
            placeholder="请选择替换后业务员"
          >
            <el-option
              v-for="item in clerkList"
              :label="`${item.userName} - ${item.loginId}`"
              :value="item.code"
              :key="item.code"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <crm-button
          :buttonType="'plain'"
          :text="'取消'"
          @click="handleDialogClose('salesman')"
        >
        </crm-button>
        <crm-button :text="'确定'" @click="handleEditSalesman()"></crm-button>
      </div>
    </el-dialog>

    <!-- 最终客户弹窗 -->
    <el-dialog
      :title="finallyCusDialog.isAdd ? '新增最终客户' : '编辑最终客户'"
      width="30%"
      append-to-body
      :visible.sync="finallyCusDialog.visible"
    >
      <el-form :model="finallyCusForm" label-width="100px" ref="finallyCusForm">
        <el-form-item
          label="客户名称："
          prop="customerName"
          :rules="[
            { required: true, message: '请填写客户名称', trigger: 'blur' },
            { max: 50, message: '最多50字', trigger: 'blur' },
          ]"
        >
          <el-input v-model="finallyCusForm.customerName"></el-input>
        </el-form-item>
        <el-form-item
          label="备注："
          prop="remark"
          :rules="{ max: 200, message: '最多200字', trigger: 'blur' }"
        >
          <el-input
            type="textarea"
            :rows="4"
            placeholder="请输入备注，最多200字"
            v-model="finallyCusForm.remark"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <crm-button
          :buttonType="'plain'"
          :text="'取消'"
          @click="handleDialogClose('finallyCus')"
        >
        </crm-button>
        <crm-button :text="'确定'" @click="handleFinallyCusSubmit()"></crm-button>
      </div>
    </el-dialog>

    <!-- 编辑客户 -->
    <edit-custom
      v-if="editCustomVisible"
      :row="editCustomRow"
      @closeEditCustom="handleDialogClose('customEdit')"
      @saveEditCustom="saveEditCustom"
    >
    </edit-custom>

    <clue-detail
      v-if="clueVisible"
      :id="clueId"
      @close="clueVisible = false"
      @refresh="clueVisible = false"
    >
    </clue-detail>
    <!-- 新增 -->
    <add-visit
      v-if="isAddVisitVisible"
      :visible="isAddVisitVisible"
      :detail="visitDetail"
      @close="isAddVisitVisible = false"
      @success="updatePanel"
    >
    </add-visit>
    <el-image-viewer
      v-if="imagePreview.showImage"
      :on-close="closeViewer"
      :url-list="[...imagePreview.url]"
    />
    <!--选择已有合同-->
    <choose-contract ref="chooseContract"
                     :isCustom="true"
                     @success="chooseSuccess"
                     :customName="customFullName"
                     :customId="uid"/>
  </crm-side-panel>
</template>

<script>
/* eslint-disable */
import { mapActions, mapGetters } from "vuex";
import { formatTimeShow, formatMoney, formatTimeFull } from "@/scripts/utils";
import { uploadFileVerify } from "@/scripts/reg";

import BusiDetail from "~component/business/busiopportunity/busiDetail.vue";
import CompactDetail from "~component/business/compact/detail.vue";
import AddUpdate from "~component/business/compact/AddUpdate.vue";
import AddProject from "~component/business/project/addProject.vue";
import AddCompact from "~component/business/compact/AddCompact.vue";
import EditCustom from "~component/business/custom/editCustom";
import CrmSidePanel from "~component/base/crmSidePanel.vue";
import CrmButton from "@/components/base/crmButton";
import AddBusi from "~component/business/busiopportunity/addBusi";
import PaneInfo from "./pane-info.vue";
import AddVisit from "@/components/business/visit/addVisit";
import cookie from 'js-cookie'
import { Loading } from 'element-ui'
import projectService from '~api/project'
import services from '~api/customer';
import CompactDetailInside from "@/pages/compact-inside/component";
import ChooseContract from "@/components/business/busiopportunity/chooseContract.vue";

export default {
  components: {
    BusiDetail,
    CompactDetail,
    CompactDetailInside,
    AddUpdate,
    AddCompact,
    EditCustom,
    CrmSidePanel,
    CrmButton,
    AddBusi,
    PaneInfo,
    AddProject,
    AddVisit,
    ChooseContract,
    ClueDetail() {
      return import("@/components/business/clue/detail.vue");
    },
    "el-image-viewer": () => import("element-ui/packages/image/src/image-viewer"),
  },
  filters: {
    formatTimeShow,
    formatTimeFull,
    orgStateFilter(val) {
      let result = "";
      if (val === 1) result = "待审核";
      if (val === 2) result = "审核通过";
      if (val === 3) result = "驳回";
      return result;
    },
  },
  props: {
    uid: {
      type: String,
      default: "",
    },
    teamId: {
      type: Number,
      default: 1,
    },
    type: {
      type: Number,
      default: 1,
    },
    authEdit: [Number, Boolean],
    authDelete: [Number, Boolean],
    authBusi: [Number, Boolean],
    sourcePart: {
      type: String,
      default: "customer",
    },
  },
  data() {
    return {
      row: {},
      imagePreview: {
        showImage: false,
        url: "",
      },
      loading: false,
      tabActiveName: "details",
      oprationDepartment: [],
      isDoctorOperator: this.userInfo && this.userInfo.categoryTeamType === "5",
      contacts: {
        pageNumber: 1,
        pageSize: 10,
        results: [{}],
        totalCount: 1,
        totalPages: 1,
      },
      archive: {
        pageNumber: 1,
        pageSize: 10,
        results: [{}],
        totalCount: 1,
        totalPages: 1,
      },
      finallyCustom: {
        pageNumber: 1,
        pageSize: 10,
        results: [{}],
        totalCount: 1,
        totalPages: 1,
      },
      visits: {
        pageNumber: 1,
        pageSize: 10,
        results: [{}],
        totalCount: 1,
        totalPages: 1,
      },
      busi: {
        pageNumber: 1,
        pageSize: 10,
        results: [],
        totalCount: 1,
        totalPages: 1,
      },
      compact: {
        pageNumber: 1,
        pageSize: 10,
        results: [],
        totalCount: 1,
        totalPages: 1,
      },
      project: {
        pageNumber: 1,
        pageSize: 10,
        results: [],
        totalCount: 1,
        totalPages: 1,
      },
      // 编辑客户
      editCustomVisible: false,
      editCustomRow: {},
      // 商机详情
      busiDetailVisible: false,
      detailId: "",
      nextButtonState: false,
      // 新增商机
      addUpdateBusiVisible: false,
      isAdd: false,
      busiOpportunityDetail: {},
      isAddBusiVisible: false,
      // 合同详情
      compactDetailId: "",
      compactDetailVisible: false,
      // 合同新增编辑弹窗
      addCompactDialogVisible: false,
      // 项目新增编辑弹窗
      addProjectDialogVisible: false,
      clickFrom: "",
      addUpdateVisible: false,
      detail: {},
      // 联系人
      addConvertVisibility: false,
      addConvertForm: {
        name: "",
        mobile: "",
        duty: "",
        contactType: "",
        customerUid: this.uid,
        contactEmail: "",
        contactDepa: "",
        salesmanCode: "",
      },
      finallyCusDialog: {
        isAdd: true,
        visible: false,
      },
      finallyCusForm: {
        customerUid: this.uid,
        customerName: null,
        remark: null,
      },
      updateConvertVisibility: false,
      updateConvertForm: {
        uid: "",
        name: "",
        mobile: "",
        duty: "",
        contactType: "",
        customerUid: this.uid,
        contactEmail: "",
        contactDepa: "",
        salesmanCode: "",
      },
      convertFormRules: {
        contactType: [{ required: true, message: "请选择联系人类型", trigger: "change" }],
        name: [
          { required: true, message: "请填写联系人", trigger: "blur" },
          { max: 20, message: "最多20字", trigger: "blur" },
        ],
        mobile: [
          { required: true, message: "请填写联系方式", trigger: "blur" },
          {
            min: 8,
            message: "请输入不少于8位的固话或者手机号",
            trigger: "blur",
          },
          { max: 20, message: "最多20字", trigger: "blur" },
          {
            pattern: /^(\d{11})|^((\d{7,8})|(\d{4}|\d{3})-(\d{7,8})|(\d{4}|\d{3})-(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1})|(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1}))$/,
            message: "请输入固话或者手机号",
          },
        ],
        duty: [
          { required: true, message: "请填写联系人职务", trigger: "blur" },
          { max: 20, message: "最多20字", trigger: "blur" },
        ],
        contactDepa: [
          { required: true, message: "请填写联系人部门", trigger: "blur" },
          { max: 20, message: "最多20字", trigger: "blur" },
        ],
        salesmanCode: [{ required: true, message: "请选择业务员", trigger: "change" }],
        contactEmail: [{ max: 30, message: "最多30字", trigger: "blur" }],
        landline: [
          {
            pattern: /^(\d+-\d+|\d*)$/,
            message: "座机必须为数字",
            trigger: "blur",
          },
          { max: 20, message: "最多20字", trigger: "blur" },
        ],
        contactQQ: [
          {
            pattern: /^[a-zA-Z0-9_-]+$/,
            message: "不能输入特殊符号",
            trigger: "blur",
          },
          { max: 20, message: "最多20字", trigger: "blur" },
        ],
      },
      // 业务员弹窗
      addSalesmanDialogVisible: false,
      addSalesmanForm: {
        character: null,
        code: null,
      },
      editSalesmanDialogVisible: false,
      editSalesmanForm: {
        crmSalesmans: [],
        newCode: null,
        code: null,
        name: null,
      },
      clueVisible: false,
      clueId: null,
      isAddVisitVisible: false,
      visitDetail: {},
      compactDetail: {},
      envCrm: cookie.get("_env_crm__") !== "false",
      compactRow: {},
      compactDetailVisibleInside: false,
      activities: [],
    };
  },
  computed: {
    ...mapGetters({
      businessAuth: "authority/businessAuth",
      customAuth: "authority/customAuth",
      visitAuth: "authority/visitAuth",
      medicalCustomAuth: "authority/medicalCustomAuth",
      webCustomerAuth: "authority/webCustomerAuth",
      webCompactAuth: "authority/webCompactAuth",
      customDetail: "customer/customDetail",
      customSalesman: "customer/customSalesman",
      customContacts: "customer/customContacts",
      finallyCustomData: "customer/finallyCustomData",
      customVisits: "customer/customVisits",
      customBusi: "customer/customBusi",
      customCompact: "customer/customCompact",
      contactsType: "common/contactsType",
      customArchiveData: "customer/customArchiveData",
      clerkList: "common/clerkList",
      projectList: "customer/projectList",
      projectDetailList: "customer/projectDetailList",
      userInfo: "authority/userInfo",
      apiBusiOpportunityDetail: "business/busiOpportunityDetail",
    }),
    customFullName() {
      const { name, depaName } = this.customDetail.commonCustomer;
      return [name, depaName].filter(Boolean).join("-");
    },
    customFullRegion() {
      const { province, city, district } = this.customDetail.commonCustomer;
      return [province, city, district].filter(Boolean).join("-");
    },
  },
  watch: {
    uid(val) {
      this.tabActiveName = "details";
      if (val) {
        this.updatePanel();
      }
    },
  },
  methods: {
    ...mapActions({
      getBusiOpprtunityDetail: "business/getBusiOpprtunityDetail",
      getAuthority: "authority/getAuthority",
      getCustomDetail: "customer/getCustomDetail",
      getSalesmanList: "customer/getSalesmanList",
      getCustomContacts: "customer/getCustomContacts",
      getCustomVisits: "customer/getCustomVisits",
      getCustomBusi: "customer/getCustomBusi",
      getCustomCompact: "customer/getCustomCompact",
      getProjectList: "customer/getProjectList",
      getContactsType: "common/getContactsType",
      addConvert: "customer/addConvert",
      updateConvert: "customer/updateConvert",
      deleteConvert: "customer/deleteConvert",
      getCustomArchive: "customer/getCustomArchive",
      getFinallyCustom: "customer/getFinallyCustom",
      uploadFile: "customer/uploadFile",
      deleteFile: "customer/deleteFile",
      getClerkList: "common/getClerkList",
      addCustomSalesman: "customer/addCustomSalesman",
      updateCustomSalesman: "customer/updateCustomSalesman",
      deleteCustomSalesman: "customer/deleteCustomSalesman",
      addFinallyCustom: "customer/addFinallyCustom",
      editFinallyCustom: "customer/editFinallyCustom",
      deleteFinallyCus: "customer/deleteFinallyCus",
      deleteCustom: "customer/deleteCustom",
      getCustomProject: "customer/getCustomProject",
      getBusiOpportunityList: "business/getBusiOpportunityList",
    }),
    formatMoney,
    toClueDetail(id) {
      this.clueVisible = true;
      this.clueId = id;
    },
    getModuleAuth(authName1, authName2) {
      if (this.sourcePart === "customer") {
        return this.customAuth[authName1]?.toggleStatus;
      }
      return this.medicalCustomAuth[authName2]?.toggleStatus;
    },
    saveEditCustom() {
      this.editCustomVisible = false;
      this.updatePanel();
      this.$emit("saveEditCustom");
    },
    htmlDecodeByRegExp(str) {
      var s = "";
      if (str.length === 0) return "";
      s = str.replace(/&amp;/g, "&");
      s = s.replace(/&lt;/g, "<");
      s = s.replace(/&gt;/g, ">");
      s = s.replace(/&nbsp;/g, " ");
      s = s.replace(/&#39;/g, "'");
      s = s.replace(/&quot;/g, '"');
      return s;
    },
    closeViewer() {
      this.imagePreview.showImage = false;
      this.move();
    },
    // 停止页面滚动
    stopMove() {
      const m = (e) => {
        e.preventDefault();
      };
      document.body.style.overflow = "hidden";
      document.addEventListener("touchmove", m, { passive: false }); // 禁止页面滑动
    },
    // 开启页面滚动
    move() {
      const m = (e) => {
        e.preventDefault();
      };
      document.body.style.overflow = "auto"; // 出现滚动条
      document.removeEventListener("touchmove", m, { passive: true });
    },
    getFildUrl(row) {
      this.imagePreview.url = "";
      const typeArr = row.fileName.split(".");
      if (["png", "jpg", "jpeg"].includes(typeArr[typeArr.length - 1])) {
        this.imagePreview.url = row.previewUrl;
        this.imagePreview.showImage = true;
        this.stopMove();
        return;
      }
      if (typeArr[typeArr.length - 1] === "pdf") {
        window.open(row.previewUrl);
        return;
      }
      const url = this.htmlDecodeByRegExp(row.fileUrl);
      window.open(`https://view.officeapps.live.com/op/view.aspx?src=${url}`);
    },
    handleDelete() {
      if (
        !this.customDetail.commonCustomer.salesmanCode
          .split(",")
          .includes(this.userInfo.userUid)
      ) {
        this.$message({
          message: "请修改业务员为本人后再进行释放操作！",
        });
        return;
      }
      this.$confirm(
        this.customDetail.commonCustomer.categoryUid ===
          "b8b2e093efd548a18259807bcb7fda2f"
          ? "此操作将永久删除该客户, 是否继续?"
          : "此操作将把该客户释放到公海，是否继续？",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        this.deleteCustom({
          uid: [this.uid],
          sourcePart: this.sourcePart || "",
        })
          .then(() => {
            this.customDetailShow = false;
            this.$message({
              type: "success",
              message:
                this.customDetail.commonCustomer.categoryUid !==
                "b8b2e093efd548a18259807bcb7fda2f"
                  ? "操作成功！"
                  : "删除成功!",
            });
            this.handleDialogClose("thisDialog");
          })
          .catch(() => {});
      });
    },
    handleSizeChange(val) {
      this[this.tabActiveName].pageSize = val;
      this[this.tabActiveName].pageNumber = 1;

      this.updatePanel();
    },
    handleCurrentChange(val) {
      this[this.tabActiveName].pageNumber = val;
      this.updatePanel();
    },
    handleTabClick() {
      if (
        [
          "contacts",
          "archive",
          "finallyCustom",
          "visits",
          "busi",
          "compact",
          "project",
        ].includes(this.tabActiveName)
      ) {
        this[this.tabActiveName].pageSize = 10;
        this[this.tabActiveName].pageNumber = 1;
      }
      this.updatePanel();
    },

    // tab页数据获取
    updatePanel() {
      let p = null;
      this.loading = true;
      switch (this.tabActiveName) {
        case "details":
          p = this.apiGetCustomDetail();
          break;
        case "salesman":
          p = this.apiGetSalesmanList();
          break;
        case "contacts":
          p = this.apiGetCustomContacts();
          break;
        case "archive":
          p = this.apiCustomArchive();
          break;
        case "finallyCustom":
          p = this.apiFinallyCustom();
          break;
        case "visits":
          p = this.apiGetCustomVisits();
          break;
        case "busi":
          p = this.apiGetCustomBusi();
          break;
        case "compact":
          p = this.apiGetCustomCompact();
          break;
        case "project":
          p = this.apiGetProjectList();
          break;
        case "operateLog":
          p = this.getOperateList();
          break;
        default:
          p = Promise.reject();
          break;
      }
      p.finally(() => {
        this.loading = false;
      });
    },
    // tab页数据获取-详情
    apiGetCustomDetail() {
      return this.getCustomDetail({
        sourcePart: this.sourcePart,
        uid: this.uid,
      }).then(() => {
        this.oprationDepartment = [];
        if (this.customDetail?.customerDetail) {
          this.customDetail.customerDetail.forEach((item) => {
            this.oprationDepartment.push(item.dictName);
          });
        }
      });
    },
    apiGetSalesmanList() {
      return this.getSalesmanList({
        customerUid: this.uid,
        pageNumber: 1,
        pageSize: 100,
        sourcePart: this.sourcePart || "",
      });
    },
    // tab页数据获取-联系人
    apiGetCustomContacts() {
      return this.getCustomContacts({
        customerUid: this.uid,
        pageNumber: this.contacts.pageNumber,
        pageSize: this.contacts.pageSize,
        sourcePart: this.sourcePart || "",
      }).then(() => {
        if (this.customContacts.results.length === 0 && this.contacts.pageNumber !== 1) {
          this.contacts.pageNumber = 1;
          this.apiGetCustomContacts();
        }
      });
    },
    // tab页数据获取-客户档案
    apiCustomArchive() {
      return this.getCustomArchive({
        bizUid: this.uid,
        pageNumber: this.archive.pageNumber,
        pageSize: this.archive.pageSize,
        sourcePart: this.sourcePart || "",
      }).then(() => {
        if (
          this.customArchiveData.results.length === 0 &&
          this.archive.pageNumber !== 1
        ) {
          this.archive.pageNumber = 1;
          this.apiCustomArchive();
        }
      });
    },
    apiFinallyCustom() {
      return this.getFinallyCustom({
        customerUid: this.uid,
        pageNumber: this.finallyCustom.pageNumber,
        pageSize: this.finallyCustom.pageSize,
        sourcePart: this.sourcePart || "",
      }).then(() => {
        if (
          this.finallyCustomData.results.length === 0 &&
          this.finallyCustom.pageNumber !== 1
        ) {
          this.finallyCustom.pageNumber = 1;
          this.apiFinallyCustom();
        }
      });
    },
    // tab页数据获取-拜访
    apiGetCustomVisits() {
      return this.getCustomVisits({
        customerUid: this.uid,
        pageNumber: this.visits.pageNumber,
        pageSize: this.visits.pageSize,
        sourcePart: this.sourcePart || "",
      }).then(() => {
        if (this.customVisits?.results?.length === 0 && this.visits.pageNumber !== 1) {
          this.visits.pageNumber = 1;
          this.apiGetCustomVisits();
        }
      });
    },
    // tab页数据获取-商机
    apiGetCustomBusi() {
      return this.getCustomBusi({
        customerId: this.uid,
        pageNumber: this.busi.pageNumber,
        pageSize: this.busi.pageSize,
        sourcePart: this.sourcePart || "",
      }).then(() => {
        if (this.customBusi.results.length === 0 && this.busi.pageNumber !== 1) {
          this.busi.pageNumber = 1;
          this.apiGetCustomBusi();
        }
      });
    },
    // tab页数据获取-合同
    apiGetCustomCompact() {
      return this.getCustomCompact({
        customerId: this.uid,
        pageNumber: this.compact.pageNumber,
        pageSize: this.compact.pageSize,
        sourcePart: this.sourcePart || "",
      }).then(() => {
        if (this.customCompact.results.length === 0 && this.compact.pageNumber !== 1) {
          this.compact.pageNumber = 1;
          this.apiGetCustomCompact();
        }
      });
    },
    // tab页数据获取-项目
    apiGetProjectList() {
      return this.getCustomProject({
        customerId: this.uid,
        pageNumber: this.project.pageNumber,
        pageSize: this.project.pageSize,
        sourcePart: this.sourcePart || "",
      }).then(() => {
        if (
          this.projectDetailList.results.length === 0 &&
          this.projectDetailList.pageNumber !== 1
        ) {
          this.project.pageNumber = 1;
          this.apiGetProjectList();
        }
      });
    },

    // 显示弹窗
    // 根据type，也就是tab名判断属于哪个tab的弹窗
    // 根据scope有无，判断新增还是编辑
    handleDialogShow(type, scope) {
      switch (type) {
        case "customEdit":
          this.handleOpenCustomEdit();
          break;
        case "salesman":
          this.handleOpenSalesman(scope);
          break;
        case "finallyCus":
          this.handleOpenFinallyCus(scope);
          break;
        case "contacts":
          this.handleOpenContacts(scope);
          break;
        case "busi":
          this.handleOpenBusi();
          break;
        case "contract":
          this.handleOpenContract();
          break;
        case "project":
          this.handleOpenProject();
          break;
        default:
          break;
      }
    },
    // 显示弹窗-客户编辑
    handleOpenCustomEdit() {
      this.editCustomVisible = true;
      this.editCustomRow = {
        uid: this.uid,
      };
    },
    // 显示弹窗-业务员
    handleOpenSalesman(scope) {
      this.getClerkList({
        sourcePart: this.sourcePart || "",
      });
      if (scope) {
        this.editSalesmanForm.crmSalesmans = [this.uid];
        this.editSalesmanForm.code = scope.row.salesmanCode;
        this.editSalesmanForm.name = scope.row.salesmanName;
        this.editSalesmanDialogVisible = true;
      } else {
        this.addSalesmanDialogVisible = true;
      }
    },
    // 显示弹窗-最终客户
    handleOpenFinallyCus(scope) {
      this.finallyCusDialog.visible = true;
      if (scope) {
        this.finallyCusDialog.isAdd = false;
        this.finallyCusForm.customerName = scope.row.customerName;
        this.finallyCusForm.remark = scope.row.remark;
        this.finallyCusForm.id = scope.row.id;
      } else {
        this.finallyCusDialog.isAdd = true;
        this.finallyCusForm.customerName = null;
        this.finallyCusForm.remark = null;
      }
    },
    // 显示弹窗-联系人
    handleOpenContacts(scope) {
      // 联系人类型列表
      this.getContactsType({
        code: "category_contact",
      });
      this.getSalesmanList({
        customerUid: this.uid,
        pageNumber: 1,
        pageSize: 100,
        sourcePart: this.sourcePart || "",
      }).then(() => {
        const salesman = this.customSalesman.results;
        if (salesman.length) this.addConvertForm.salesmanCode = salesman[0].salesmanCode;
      });
      if (scope) {
        this.updateConvertForm = scope.row;
        this.updateConvertVisibility = true;
      } else {
        this.addConvertVisibility = true;
        this.addConvertForm.customerUid = this.uid;
      }
    },
    // 显示弹窗-商机
    handleOpenBusi() {
      this.busiOpportunityDetail.customerId = this.uid;
      this.isAddBusiVisible = true;
      // this.addUpdateBusiVisible = true;
    },
    // 区分内部、外部（内部打开OA，外部维持原样）
    async handleOpenContract() {
      const envCrm = cookie.get('_env_crm__') !== 'false'
      if (envCrm) {
        let loadingInstance = Loading.service({
          fullscreen: true,
          text: '正在打开新页面，请稍后……',
        })
        const tokenData = await projectService.getOaTokenInside()
        const flag = window.location.hostname.includes('crm.guahao-test.com')
        const oaEnv = flag ? `${window.location.protocol}//192.168.99.106:8088/spa/workflow/static4form/index.html` : `${window.location.protocol}//procurement.guahao.com/spa/workflow/static4form/index.html`
        const oaUrl = flag ? `#/main/workflow/req?iscreate=1&workflowid=49&_key=vc6ucz` : `#/main/workflow/req?iscreate=1&workflowid=173&_key=wkgn4i`
        // 1、默认带入“收支类型”为“收入类”
        // 销售合同才有以下2项（field7148=11）
        // 2、带入该客户的“客户名称”field7242  field7229
        // 3、业务员可选范围为该客户下的业务员(“业务员”)
        if(flag){
          const OAUrl = oaEnv +
          `?ssoToken=${tokenData.data.data}${oaUrl}&field7134=${0}&field7148=11&field7242=${this.customDetail.commonCustomer.uid}&field7229=${this.customDetail.commonCustomer.name}&field8400=${this.customDetail.commonCustomer.salesmanCode}`
          window.open(OAUrl)
        }else{
          const OAUrl = oaEnv +
          `?ssoToken=${tokenData.data.data}${oaUrl}&field11608=${0}&field11622=11&field7242=${this.customDetail.commonCustomer.uid}&field7229=${this.customDetail.commonCustomer.name}&field8400=${this.customDetail.commonCustomer.salesmanCode}`
          window.open(OAUrl)
        }
        setTimeout(() => {
          this.$nextTick(() => {
            loadingInstance.close()
          })
        }, 2000)
      } else {
        this.addCompactDialogVisible = true
        this.compactDetail = {
          customName: this.customDetail.commonCustomer.name,
          customId: this.customDetail.commonCustomer.uid,
          salesmanCode:
            this.customDetail.commonCustomer.salesmanCode || this.userInfo.userUid,
          name: this.customDetail.commonCustomer.name,
          id: '',
          productLineList: [],
          form: 'custom',
        }
      }
    },
    // 显示弹窗-项目
    handleAddProject (type) {
      if (type === 'addHad') {
        this.handleOpenProject()
      } else {
        this.handleConnectOA()
      }
    },

    handleOpenProject() {
      this.addProjectDialogVisible = true;
    },
    // 新建项目
    async handleConnectOA() {
      let loadingInstance = Loading.service({
        fullscreen: true,
        text: "正在打开新页面，请稍后……",
      });
      const tokenData = await projectService.getOaToken();
      const oaEnv = (window.location.hostname.includes('guahao-test.com')) ? `${window.location.protocol}//192.168.99.106:8088/spa/workflow/static4form/index.html` : `${window.location.protocol}//procurement.guahao.com/spa/workflow/static4form/index.html`
      const oaPath = (window.location.hostname.includes('guahao-test.com')) ? `?ssoToken=${tokenData.data.data}&_rdm=1644891818776#/main/workflow/req?iscreate=1&workflowid=54` : `?ssoToken=${tokenData.data.data}#/main/workflow/req?workflowid=108&iscreate=1`
      if (this.apiBusiOpportunityDetail && this.apiBusiOpportunityDetail.productLineList) {
        const businessLineIdsStr = this.apiBusiOpportunityDetail.productLineList.reduce(
          (result, nextItem) => {
            if (result === "") {
              result += nextItem.bfmUid;
            } else {
              result += "," + nextItem.bfmUid;
            }
            return result;
          },
          ""
        );
        if (window.location.hostname.includes('guahao-test.com')) {
          this.OAUrl =
            oaEnv + oaPath +
            `&field11232=${businessLineIdsStr}&field11262=${businessLineIdsStr}&field8940=${this.apiBusiOpportunityDetail.id}`;
        } else {
          this.OAUrl =
            oaEnv + oaPath +
            `&field11232=${businessLineIdsStr}&field11262=${businessLineIdsStr}&field13028=${this.apiBusiOpportunityDetail.id}`;
        }
      } else {
        this.OAUrl =
          oaEnv + oaPath +
          `&field15064=${this.uid}`;
      }
      window.open(this.OAUrl);
      setTimeout(() => {
        this.$nextTick(() => {
          loadingInstance.close();
        });
      }, 2000);
    },

    // 关闭弹窗
    // 根据isAdd判断新增弹窗还是编辑弹窗
    handleDialogClose(type, isAdd) {
      switch (type) {
        case "thisDialog":
          this.$emit("closeCustomDetail");
          break;
        case "customEdit":
          this.editCustomVisible = false;
          break;
        case "busi":
          this.addUpdateBusiVisible = false;
          break;
        case "contract":
          this.addCompactDialogVisible = false;
          break;
        case "finallyCus":
          this.finallyCusDialog.visible = false;
          this.$refs.finallyCusForm.resetFields();
          break;
        case "salesman":
          if (isAdd) {
            this.addSalesmanDialogVisible = false;
            this.$refs.addSalesmanForm.resetFields();
          } else {
            this.editSalesmanDialogVisible = false;
            this.$refs.editSalesmanForm.resetFields();
          }
          break;
        case "contacts":
          if (isAdd) {
            this.$refs.addConvertForm.resetFields();
            this.addConvertVisibility = false;
          } else {
            this.$refs.updateConvertForm.resetFields();
            this.updateConvertVisibility = false;
          }
          break;
        case "project":
          this.addProjectDialogVisible = false;
          break;
        default:
          break;
      }
    },

    // 附件表格-上传校验
    async beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 50;

      if (!isLt2M) {
        this.$message.error("上传文件大小不能超过 50MB!");
        return Promise.reject();
      }
      /* eslint-disable */
      try {
        return await uploadFileVerify(file.name);
      } catch (e) {
        this.$message(e);
        return Promise.reject();
      }
    },
    // 附件表格-上传
    handleUploadFile(item) {
      this.notify = this.$notify({
        iconClass: "el-icon-loading",
        title: "",
        message: "正在上传中，请稍后...",
        duration: 0,
        showClose: false,
      });
      const params = new FormData();
      params.append("file", item.file);
      params.append("fileName", item.file.name);
      params.append("bizUid", this.uid);
      params.append("sourcePart", this.sourcePart || "");

      this.uploadFile({
        params,
        config: { "Content-Type": "multipart/form-data", timeout: 100000 },
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "上传成功！",
          });
          this.apiCustomArchive();
        })
        .finally(() => {
          if (this.notify) this.notify.close();
        });
    },
    // 附件表格-删除
    handleDeleteFile(scope) {
      this.$confirm("是否确定删除该档案？", "", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.deleteFile({
            id: scope.row.id,
            sourcePart: this.sourcePart || "",
          }).then(() => {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.apiCustomArchive();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    // 联系人-新增
    handleAddConvert() {
      this.$refs.addConvertForm.validate().then((valid) => {
        if (valid) {
          this.addConvert({
            ...this.addConvertForm,
            sourcePart: this.sourcePart || "",
          }).then(() => {
            this.$message({
              type: "success",
              message: "新增成功！",
            });
            this.addConvertVisibility = false;
            this.$refs.addConvertForm.resetFields();
            this.apiGetCustomContacts();
          });
        }
      });
    },
    // 联系人-编辑
    handleUpdateConvert() {
      this.$refs.updateConvertForm.validate().then((valid) => {
        if (valid) {
          this.updateConvert({
            ...this.updateConvertForm,
            sourcePart: this.sourcePart || "",
          }).then(() => {
            this.$message({
              type: "success",
              message: "修改成功！",
            });
            this.updateConvertVisibility = false;
            this.$refs.updateConvertForm.resetFields();
            this.apiGetCustomContacts();
          });
        }
      });
    },
    // 联系人-删除
    handleDeleteConvert(scope) {
      this.deleteConvert({
        uid: scope.row.uid,
        sourcePart: this.sourcePart || "",
      }).then(() => {
        this.$message({
          type: "success",
          message: "删除成功！",
        });

        this.apiGetCustomContacts();
      });
    },

    // 商机-打开详情
    async handleBusiDetailShow(scope) {
      if (this.businessAuth?.bizDetailTab?.toggleStatus) {
        await this.getBusiOpprtunityDetail({ id: scope.row.id })
          .then((res) => {
            this.nextButtonState = true;
            this.detailId = scope.row.id;
            this.busiDetailVisible = true;
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        this.$message.error("无操作权限!");
      }
    },
    // 商机-关闭详情
    handleCloseBusiDetail(isRefresh) {
      this.busiDetailVisible = false;
      this.nextButtonState = false;
      if (isRefresh) {
        this.apiGetCustomBusi();
      }
    },
    // 商机-新增
    saveAddUpdate() {
      this.addUpdateBusiVisible = false;
      this.apiGetCustomBusi();
    },

    // 合同-打开详情
    handleCompactDetailShow(scope) {
      if (this.envCrm) {
        this.compactRow = scope.row;
        this.detailId = scope.row.id;
        this.compactDetailVisibleInside = true;
      } else {
        this.row = scope.row;
        this.compactDetailId = scope.row.id;
        this.compactDetailVisible = true;
      }
    },
    // 合同-关闭详情
    handleCloseCompactDetail(isRefresh) {
      this.compactDetailVisible = false;
      this.compactDetailVisibleInside = false;
      if (isRefresh) {
        this.apiGetCustomCompact();
      }
    },
    // 合同-新增
    handleAddCompact() {
      this.addCustomId = this.uid;
      this.clickFrom = "customAdd";
      this.addUpdateVisible = true;
    },

    // 业务员-新增
    handleAddSalesman() {
      this.$refs.addSalesmanForm.validate().then((valid) => {
        if (valid) {
          this.addCustomSalesman({
            sourcePart: this.sourcePart || "",
            code: this.addSalesmanForm.code,
            crmSalesmans: [this.uid],
          }).then(() => {
            this.$message.success("新增成功");
            this.addSalesmanDialogVisible = false;
            this.updatePanel();
            this.apiGetCustomDetail();
          });
        }
      });
    },
    // 业务员-编辑
    handleEditSalesman() {
      this.$refs.editSalesmanForm.validate().then((valid) => {
        if (valid) {
          this.updateCustomSalesman({
            ...this.editSalesmanForm,
            sourcePart: this.sourcePart || "",
          }).then(() => {
            this.$message.success("编辑成功");
            this.editSalesmanDialogVisible = false;
            this.updatePanel();
            this.apiGetCustomDetail();
          });
        }
      });
    },
    // 业务员-删除
    handleDeleteSalesman(scope) {
      this.$confirm("此操作将永久删除该业务员, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.deleteCustomSalesman({
          id: scope.row.id,
          sourcePart: this.sourcePart || "",
        })
          .then(() => {
            this.updatePanel();
            this.apiGetCustomDetail();
            this.$message({
              type: "success",
              message: "删除成功!",
            });
          })
          .catch(() => {});
      });
    },
    // 最终客户-新增、编辑
    handleFinallyCusSubmit() {
      this.$refs.finallyCusForm.validate().then((valid) => {
        if (valid) {
          this.finallyCusForm.customerUid = this.uid;
          const p = this.finallyCusDialog.isAdd
            ? this.addFinallyCustom({
                ...this.finallyCusForm,
                sourcePart: this.sourcePart || "",
              })
            : this.editFinallyCustom({
                ...this.finallyCusForm,
                sourcePart: this.sourcePart || "",
              });
          p.then(() => {
            this.finallyCusDialog.visible = false;
            this.updatePanel();
          });
        }
      });
    },
    // 最终客户-删除
    handleDeleteFinallyCus(scope) {
      this.$confirm("此操作将永久删除该最终客户, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.deleteFinallyCus({
          id: scope.row.id,
          sourcePart: this.sourcePart || "",
        })
          .then(() => {
            this.updatePanel();
            this.$message({
              type: "success",
              message: "删除成功!",
            });
          })
          .catch(() => {});
      });
    },
    // 拜访
    toVisit() {
      this.visitDetail = {
        visitObject: 1,
        visitObjectId: this.customDetail.commonCustomer.uid,
        customName: this.customDetail.commonCustomer.name,
        customerId: this.customDetail.commonCustomer.uid,
        salesmanCode: this.userInfo.userUid,
        cluesVisible: false,
        customVisible: false,
        contactVisible: true,
        buisVisible: false,
        canEdit: false,
      };
      this.isAddVisitVisible = true;
    },
    // 新建合同
    handleAddContract(type) {
      if (type === "addHad") {
        this.$refs.chooseContract && this.$refs.chooseContract.open()
      } else {
        this.handleDialogShow('contract')
      }
    },
    // 关联已有合同后，刷新列表
    chooseSuccess(){
      let p = null;
      this.loading = true;
      this.compact.pageSize = 10;
      this.compact.pageNumber = 1;
      p = this.updatePanel();
      p.finally(() => {
        this.loading = false;
      });
    },
    // 操作记录
    async getOperateList() {
        const { data } = await services.apiGetCustomerOperationLog({customerUid: this.uid})
        this.activities = data.data
    },
  },
  mounted() {
    this.getAuthority({ menuUrl: "/visit" });
    this.getAuthority({ menuUrl: "/customer/valid" });
    this.getAuthority({ menuUrl: "/business/opportunity" });
    // 内部系统才有医生模块
    const envCrm = cookie.get("_env_crm__") !== "false";
    if (envCrm) {
      this.getAuthority({ menuUrl: "/medicalCus/vaild" });
    }
  },
};
</script>

<style lang="less">
@import "~@/styles/common.less";

.custom-details {
  height: 100%;
  display: flex;
  flex-direction: column;
  .header {
    margin-top: -6px;
    margin-left: -13px;
    .button-group {
      position: absolute;
      right: 40px;
      top: 6px;
    }
    .icon-detail-close {
      padding: 0;
      background: 0 0;
      border: none;
      outline: 0;
      cursor: pointer;
      font-size: 16px;
    }
  }
  header {
    line-height: 32px;
  }
  section {
    margin: 10px 0;
  }
  article {
    flex: 1;
    display: flex;
    .el-tabs__header {
      background-color: #f4f4f4;
      margin-left: -13px;
      padding-left: 13px;
    }
    .el-tabs--top {
      flex: 1;
      display: flex;
      flex-direction: column;
      .el-tabs__content {
        overflow: auto;
        display: flex;
        flex: 1;
        .el-tab-pane {
          width: 100%;
          height: 100px;
        }
      }
    }
  }
  ::-webkit-scrollbar-track-piece {
    display: none;
  }
  ::-webkit-scrollbar {
    width: 8px;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: rgba(0, 0, 0, 0);
  }
  :hover::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.2);
  }
}

.pagination-wrap {
  margin-top: 10px;
  text-align: center;
}

.time {
    position: absolute;
    left: -145px;
}

.el-timeline {
    padding-left: 160px;
    padding-top: 20px;
}
</style>
